export function breakpointAliasOf(identifier) {
  if (!identifier) {
    return "";
  }
  const qualified = String(identifier);
  const separatorIndex = qualified.indexOf(":");
  if (separatorIndex === -1) {
    return "";
  }
  return qualified.slice(separatorIndex + 1);
}

export function flattenVisibleIdentifiers({ rootElementId, breakpointAlias, childIdsOf, isCollapsed }) {
  const orderedIdentifiers = [];
  const walk = (elementId, ancestors) => {
    const bareId = String(elementId);
    if (ancestors.has(bareId)) {
      return;
    }
    const identifier = `${bareId}:${breakpointAlias}`;
    orderedIdentifiers.push(identifier);
    if (isCollapsed(identifier)) {
      return;
    }
    const childIds = childIdsOf(bareId, identifier);
    if (!childIds || !childIds.length) {
      return;
    }
    const nextAncestors = new Set(ancestors);
    nextAncestors.add(bareId);
    childIds.forEach(childId => walk(childId, nextAncestors));
  };
  walk(rootElementId, new Set());
  return orderedIdentifiers;
}

export function identifiersBetween(orderedIdentifiers, anchorIdentifier, targetIdentifier) {
  const anchorIndex = orderedIdentifiers.indexOf(anchorIdentifier);
  const targetIndex = orderedIdentifiers.indexOf(targetIdentifier);
  if (targetIndex === -1) {
    return [];
  }
  if (anchorIndex === -1) {
    return [targetIdentifier];
  }
  const from = Math.min(anchorIndex, targetIndex);
  const to = Math.max(anchorIndex, targetIndex);
  return orderedIdentifiers.slice(from, to + 1);
}
